import React from 'react';
import { NotificationDropdownProps, Notification } from './types';
import { NotificationItem } from './NotificationItem';

export function NotificationsDropdown({ 
  notifications, 
  isLoading, 
  onNotificationClick, 
  onMarkAsRead, 
  onViewAll 
}: NotificationDropdownProps) {
  if (isLoading) {
    return (
      <div className="w-80 bg-white border border-gray-200 rounded-lg shadow-lg">
        <div className="p-4">
          <div className="animate-pulse">
            <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
            <div className="h-3 bg-gray-200 rounded w-1/2"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="w-80 bg-white border border-gray-200 rounded-lg shadow-lg">
      {/* Notifications List */}
      <div className="max-h-96 overflow-y-auto">
        {notifications.length === 0 ? (
          <div className="p-4 text-center text-gray-500 text-sm">
            No notifications yet
          </div>
        ) : (
          notifications.map((notification: Notification) => (
            <NotificationItem
              key={notification.id}
              notification={notification}
              onClick={() => onNotificationClick(notification)}
              onMarkAsRead={() => onMarkAsRead(notification.id)}
              formattedDescription={(notification as any).formattedDescription}
            />
          ))
        )}
      </div>

      {/* Footer - Always show */}
      <div className="p-3 border-t border-gray-200">
        <button
          onClick={onViewAll}
          className="w-full text-center text-sm text-blue-600 hover:text-blue-800 font-medium"
        >
          See all notifications
        </button>
      </div>
    </div>
  );
}
